<template lang="pug">
  MyCustomeCalendarControl(
    v-if="isDateRange"
    @apply='updateValues'
  )
  el-date-picker(
    v-else-if="!isDateRange"
    v-model='value2'
    :type='type'
    :key = 'type'
    :format='format'
    range-separator="To",
    start-placeholder="Start date"
    end-placeholder="End date"
    placeholder='Pick a date'
    @change='getMonthRange($event)'
  )
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import MyCustomeCalendarControl from './myCalendarControl/MyCustomeCalendarControl.vue';
import { isBulkTransactionsEnabled } from '@/utils/bulkTransactionsHelper';


export default {
  name: 'CalenderControl',
  components: { DateRangePicker, MyCustomeCalendarControl },
  props: {
    isDateRange: {
      default: false,
      type: Boolean,
    },
  },
  
  // We'll check for bulk transactions mode in created hook instead
  data() {
    // Hard coded date - July 20, 2025
    const today = moment('2025-07-20');
    const startOfMonth = today.startOf('month').format('MM-DD-YYYY');
    const endOfMonth = today.endOf('month').format('MM-DD-YYYY');
    
    // For bulk transactions, we'll use last 7 days as default
    // (We'll set this in created hook)

    return {
      timepicker: false,
      singledatepicker: false,

      localData: {
        firstDay: 1,
        format: 'mm/dd/yyyy',
        separator: ' To ',
      },

      showWeekNumbers: true,
      showDropdowns: true,
      linkedCalendars: false,
      dateRange: {
        startDate: startOfMonth,
        endDate: endOfMonth,
      },
      isBulkTransactionsRoute: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      type: 'month',
      format: 'MMM yyyy',
      activeGroup: '1',
      activeIndex: '1',
      activeGroupTitle: '',
      value2: new Date(localStorage.getItem('selectedYear'), localStorage.getItem('selectedMonth') - 1),
      selectedDateRange: ['', ''],
      newMonth: '',
      newYear: '',
      activeDate: '',
      formattedStartDate: '',
      formattedEndDate: '',
    };
  },

  computed: {
    ...mapGetters('selectdate', ['startDate', 'endDate']),
  },
  watch: {
    isDateRange(value) {
      if (value) {
        this.type = 'daterange';
        this.format = 'MM/DD/yyyy';
      } else {
        this.type = 'month';
        this.format = 'MMM yyyy';
      }
      this.createdFunction();
    },

  },
  created() {
    // Check if we're on the Bulk Transactions route or bulk transactions is enabled
    this.isBulkTransactionsRoute = window.location.hash.includes('/bulk/transactions') || isBulkTransactionsEnabled();
    
    // If in bulk mode, set default date range to last 7 days
    if (this.isBulkTransactionsRoute) {
      const today = moment();
      this.dateRange.startDate = today.clone().subtract(6, 'days').format('MM-DD-YYYY');
      this.dateRange.endDate = today.format('MM-DD-YYYY');
    }
    
    this.createdFunction();
  },

  methods: {
    ...mapActions('selectdate', ['getYear', 'getMonth', 'getYear2', 'getMonth2', 'setStartDate', 'setEndDate', 'setStartMonth', 'setEndMonth', 'setStartYear', 'setEndYear', 'triggerDateChange']),

    updateValues(value) {
      this.getMonthRange(value);
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },

    createdFunction() {
      // Set default date format based on whether we're in bulk transactions mode
      if (this.isBulkTransactionsRoute) {
        // For bulk transactions, use last 7 days as default
        this.formattedStartDate = moment().subtract(6, 'days').format('MM/DD/yyyy');
        this.formattedEndDate = moment().format('MM/DD/yyyy');
      } else {
        // For regular mode, use full month
        this.formattedStartDate = moment().startOf('month').format('MM/DD/yyyy');
        this.formattedEndDate = moment().endOf('month').format('MM/DD/yyyy');
      }

      if (localStorage.getItem('selectedDate')) {
        const dateRangeObj = JSON.parse(localStorage.getItem('selectedDate'));
        this.formattedStartDate = moment(dateRangeObj.startDate).format('MM/DD/yyyy');
        this.formattedEndDate = moment(dateRangeObj.endDate).format('MM/DD/yyyy');

        localStorage.setItem('selectedMonth', new Date(this.formattedStartDate).getMonth() + 1);
        localStorage.setItem('selectedYear', new Date(this.formattedStartDate).getFullYear());
        localStorage.setItem('selectedMonth2', new Date(this.formattedEndDate).getMonth() + 1);
        localStorage.setItem('selectedYear2', new Date(this.formattedEndDate).getFullYear());

        this.setStartDate(this.formattedStartDate);
        this.setEndDate(this.formattedEndDate);
      } else {
        this.setStartDate(this.formattedStartDate);
        this.setEndDate(this.formattedEndDate);
      }


      if (this.isDateRange) {
        this.type = 'daterange';
        this.format = 'MM/dd/yyyy';
        if (this.startDate !== '') {
          this.formattedStartDate = this.startDate;
          this.formattedEndDate = this.endDate;
        } else {
          // Use appropriate defaults based on whether we're in bulk transactions mode
          if (this.isBulkTransactionsRoute) {
            this.formattedStartDate = moment().subtract(6, 'days').format('MM/DD/yyyy');
            this.formattedEndDate = moment().format('MM/DD/yyyy');
          } else {
            this.formattedStartDate = moment().startOf('month').format('MM/DD/yyyy');
            this.formattedEndDate = moment().endOf('month').format('MM/DD/yyyy');
          }
        }
        this.selectedDateRange = [this.formattedStartDate, this.formattedEndDate];
        this.setStartDate(this.formattedStartDate);
        this.setEndDate(this.formattedEndDate);
        this.setStartMonth(moment(this.formattedStartDate).format('MM'));
        this.setEndMonth(moment(this.formattedEndDate).format('MM'));
        this.setStartYear(moment(this.formattedStartDate).format('YYYY'));
        this.setEndYear(moment(this.formattedEndDate).format('YYYY'));
      }

      if (!this.isDateRange) {
        this.format = 'MMM yyyy';
        if (!localStorage.getItem('selectedMonth')) {
          localStorage.setItem('selectedMonth', new Date().getMonth() + 1);
          localStorage.setItem('selectedYear', new Date().getFullYear());
        }
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        if (dd === '01') {
          localStorage.setItem('selectedMonth', new Date().getMonth() + 1);
          localStorage.setItem('selectedYear', new Date().getFullYear());
        }
        const t = new Date(localStorage.getItem('selectedYear'), localStorage.getItem('selectedMonth') - 1);
        this.value2 = moment(t).format('MM/DD/YYYY');
      }

      const month1 = Number(localStorage.getItem('selectedMonth'));
      const year1 = Number(localStorage.getItem('selectedYear'));
      const month2 = Number(localStorage.getItem('selectedMonth2'));
      const year2 = Number(localStorage.getItem('selectedYear2'));


      let date1 = '01';
      let date2 = '01';
      if (localStorage.getItem('selectedDate')) {
        const dateRangeObj = JSON.parse(localStorage.getItem('selectedDate'));
        date1 = new Date(dateRangeObj.startDate).getDay();
        date2 = new Date(dateRangeObj.endDate).getDay();
      }
      const expenseDateGte = `${year1}-${month1}-${date1}`;
      const expenseDateLte = `${year2}-${month2}-${date2}`;
      // To Solve SH-288
      if (expenseDateGte > expenseDateLte) {
        localStorage.setItem('selectedMonth2', new Date().getMonth() + 1);
        localStorage.setItem('selectedYear2', new Date().getFullYear());
        localStorage.setItem('selectedMonth', new Date().getMonth() + 1);
        localStorage.setItem('selectedYear', new Date().getFullYear());
        const t = new Date(localStorage.getItem('selectedYear'), localStorage.getItem('selectedMonth') - 1);
        const date11 = moment(t).format('MM/DD/YYYY');
        this.value2 = [date1, date11];
      }
    },

    getMonthRange(event) {
      if (this.type === 'month') {
        if (event) {
          const date = new Date(event);
          this.newMonth = date.getMonth() + 1;
          this.newYear = date.getFullYear();
          this.activeMonth = this.newMonth;
          this.activeYear = this.newYear;
          localStorage.setItem('selectedMonth', this.activeMonth);
          localStorage.setItem('selectedYear', this.activeYear);
          localStorage.setItem('selectedMonth2', this.activeMonth);
          localStorage.setItem('selectedYear2', this.activeYear);
          this.getYear(this.activeYear);
          this.getMonth(this.activeMonth);
          this.getYear2(this.activeYear);
          this.getMonth2(this.activeMonth);
        } else {
          localStorage.setItem('selectedMonth', new Date().getMonth() + 1);
          localStorage.setItem('selectedYear', new Date().getFullYear());
          localStorage.setItem('selectedMonth2', new Date().getMonth() + 1);
          localStorage.setItem('selectedYear2', new Date().getFullYear());
          const date = new Date();
          this.newMonth = date.getMonth() + 1;
          this.newYear = date.getFullYear();
          this.activeMonth = this.newMonth;
          this.activeYear = this.newYear;
          this.getYear(this.activeYear);
          this.getMonth(this.activeMonth);
          this.getYear2(this.activeYear);
          this.getMonth2(this.activeMonth);
        }
      }

      if (this.type === 'daterange') {
        if (event.length) {
          const startDate = moment(event[0]);
          const endDate = moment(event[1]);
          
          // Check if we're in bulk transactions mode and enforce a maximum of 7 days
          if ((this.isBulkTransactionsRoute || isBulkTransactionsEnabled()) && 
              endDate.diff(startDate, 'days') > 7) {
            // Limit to 7 days from start date
            const newEndDate = moment(startDate).add(7, 'days');
            this.$message.warning('Bulk Transactions mode: Date range limited to a maximum of 7 days');
            
            // Update the end date to be 7 days from start date
            this.formattedStartDate = startDate.format('MM/DD/yyyy');
            this.formattedEndDate = newEndDate.format('MM/DD/yyyy');
            
            // Update the date picker UI
            this.selectedDateRange = [this.formattedStartDate, this.formattedEndDate];
            
            // Small timeout to ensure the UI updates
            setTimeout(() => {
              this.$forceUpdate();
            }, 100);
          } else {
            this.formattedStartDate = startDate.format('MM/DD/yyyy');
            this.formattedEndDate = endDate.format('MM/DD/yyyy');
          }
          
          this.triggerDateChange({ selectedDateRange: `${this.formattedStartDate}${this.formattedEndDate}` });
          this.setStartDate(this.formattedStartDate);
          this.setEndDate(this.formattedEndDate);
          this.setStartMonth(moment(this.formattedStartDate).format('MM'));
          this.setEndMonth(moment(this.formattedEndDate).format('MM'));
          this.setStartYear(moment(this.formattedStartDate).format('YYYY'));
          this.setEndYear(moment(this.formattedEndDate).format('YYYY'));
        } else {
          this.formattedStartDate = moment().startOf('month').format('MM/DD/YYYY');
          this.formattedEndDate = moment().endOf('month').format('MM/DD/YYYY');
          this.triggerDateChange({ selectedDateRange: `${this.formattedStartDate}${this.formattedEndDate}` });
          this.setStartDate(this.formattedStartDate);
          this.setEndDate(this.formattedEndDate);
          this.setStartMonth(moment(this.formattedStartDate).format('MM'));
          this.setEndMonth(moment(this.formattedEndDate).format('MM'));
          this.setStartYear(moment(this.formattedStartDate).format('YYYY'));
          this.setEndYear(moment(this.formattedEndDate).format('YYYY'));
        }
        this.selectedDateRange = [this.formattedStartDate, this.formattedEndDate];
      }
    },
  },
};
</script>
